import React, { useState } from 'react';
import { ListBox } from 'primereact/listbox';
import { allEncoders, groupedEncoders } from '../Utils/AllEncoders';
import { EncoderObject } from '../Types/AllTypes';
import { Button } from 'primereact/button';

type Props = {
  selectedAlgorithms: EncoderObject[];
  setSelectedAlgorithms: (inputs: EncoderObject[]) => void;
}

const AllAlgorithmsSelector = ({ selectedAlgorithms, setSelectedAlgorithms }: Props) => {


  const groupTemplate = (option: any) => {
    return (
      <div className='groupTitle'>
        <div>{option.name}</div>
      </div>
    );
  };

  const handleChange = (e: any) => {
    console.log(e.value);
    setSelectedAlgorithms(e.value);
  }
  return (
    <div>
      <ListBox multiple
        value={selectedAlgorithms}
        onChange={(e: any) => handleChange(e)}
        options={groupedEncoders}
        optionLabel="name"
        optionGroupLabel="name"
        optionGroupChildren="items"
        optionGroupTemplate={groupTemplate}
        listStyle={{ maxHeight: '13rem' }} />
      <br />
      <Button label="Clear Selection" text style={{fontSize: "1rem"}} onClick={() => setSelectedAlgorithms([])} />

    </div>
  )
}

export default AllAlgorithmsSelector